export function handleInputEnter(onSubmit: () => void) {
    return ({ key }: { key: string }) => {
        if (key.toUpperCase() == 'ENTER') {
            onSubmit()
        }
    }
}

export function resetForm() {
    Array.from(document.querySelectorAll('input')).forEach(
        (input) => (input.value = '')
    )
}

export function getTimes() {
    let i = 7
    const times = []
    do {
        let j = 0
        do {
            const text = [`0${i}`.slice(-2), `0${j}`.slice(-2)].join(':')
            times.push({
                text,
                value: text,
            })
            j = j + 5
        } while (j < 60)
        i++
    } while (i < 21)
    return times
}


export const isWholeNumber = (number: number) =>
    number - Math.floor(number) !== 0
